import { parseJWT } from '@meisterwerk/fe-authentication-sdk'

/** The user a token was issued to; null when there is no token or its claims can't be read */
export function subjectOf(token: string | null): string | null {
  if (!token) return null
  try {
    const { sub } = parseJWT(token)
    return typeof sub === 'string' && sub !== '' ? sub : null
  } catch {
    return null
  }
}

/**
 * Whose token fe-inv handed out last: a token of another user means the query cache holds the
 * previous user's data (INV-927). Read only, never verified, and trusted for nothing else.
 */
export class SessionUser {
  /** The user of the token handed out last; undefined until one was, so the first is no change */
  private last: string | null | undefined

  /**
   * Notes `token` as the one handed out now
   * @returns Whether its user is another than the last token's. A user that can't be read is no
   *   one, and the same no one each time: resetting for every such token would refetch forever.
   */
  changesTo(token: string): boolean {
    const user = subjectOf(token)
    const changed = this.last !== undefined && user !== this.last
    this.last = user
    return changed
  }
}
